import { rewardsOverviewText } from "../../settings/Constants";
import Banner from "./Banner";
import PrevArrow from "../UI/Icons/PrevArrow";
import NextArrow from "../UI/Icons/NextArrow";
import Card from "./Card";
import Line from "./Line";
import Footer from "./Footer";
import GlobalGiving from "images/rewardsOverview/globalGiving.png";
import HandHoldingHeart from "../UI/Icons/HandHoldingHeart";
import HandsHelping from "../UI/Icons/HandsHelping";
import styled from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";
import Carousel from "react-bootstrap/Carousel";

const StyledCarousel = styled(Carousel)`
  margin-top: ${rem("30px")};
  .carousel-control-next,
  .carousel-control-prev {
    width: 3%;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .sr-only-focusable:active,
  .sr-only-focusable:focus {
    position: static;
    width: auto;
    height: auto;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }
`;

const CardContainer = styled.div`
  margin: ${rem("40px")} ${rem("0px")} ${rem("16px")};
  display: flex;
  justify-content: space-between;
`;

const IconContainer = styled.div`
  height: ${rem("37px")};
  min-width: ${rem("42px")} !important;
  margin-top: ${rem("48px")};
  margin-bottom: ${rem("16px")};

  > img {
    width: ${rem("180px")};
  }

  > svg {
    width: ${rem("42px")};
  }
`;

const CardText = styled.div`
  text-align: center;
  max-width: ${rem("220px")};
  font-size: ${rem("14px")};
  font-weight: 400;
  line-height: ${rem("24px")};
  color: #666666;
`;

const StyledA = styled.a`
  text-decoration: underline;
  color: #666666;

  &:hover {
    color: #666666;
  }
`;

export const CashForACauseCards = ({ isMobileView }) => {
  return (
    <>
      {isMobileView ? (
        <StyledCarousel
          indicators={false}
          prevIcon={<PrevArrow />}
          nextIcon={<NextArrow />}
          interval={100000}
        >
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <img src={GlobalGiving} />
              </IconContainer>
              <CardText type="cashForACauseDescription">
                {rewardsOverviewText.cashForACauseSection.card1.text1}{" "}
                <StyledA href="https://www.globalgiving.org/" target="_blank">
                  GlobalGiving
                </StyledA>
                {rewardsOverviewText.cashForACauseSection.card1.text2}
              </CardText>
            </Card>
          </Carousel.Item>
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <HandsHelping />
              </IconContainer>
              <CardText type="cashForACauseDescription">
                {rewardsOverviewText.cashForACauseSection.card2.text}
              </CardText>
            </Card>
          </Carousel.Item>
          <Carousel.Item>
            <Card>
              <IconContainer section="cashForACause">
                <HandHoldingHeart />
              </IconContainer>
              <CardText type="cashForACauseDescription">
                {rewardsOverviewText.cashForACauseSection.card3.text}
              </CardText>
            </Card>
          </Carousel.Item>
        </StyledCarousel>
      ) : (
        <CardContainer>
          <Card>
            <IconContainer>
              <img src={GlobalGiving} />
            </IconContainer>
            <CardText>
              {rewardsOverviewText.cashForACauseSection.card1.text1}{" "}
              <StyledA href="https://www.globalgiving.org/" target="_blank">
                GlobalGiving
              </StyledA>
              {rewardsOverviewText.cashForACauseSection.card1.text2}
            </CardText>
          </Card>
          <Card>
            <IconContainer>
              <HandsHelping />
            </IconContainer>
            <CardText>
              {rewardsOverviewText.cashForACauseSection.card2.text}
            </CardText>
          </Card>
          <Card>
            <IconContainer>
              <HandHoldingHeart />
            </IconContainer>
            <CardText>
              {rewardsOverviewText.cashForACauseSection.card3.text}
            </CardText>
          </Card>
        </CardContainer>
      )}
    </>
  );
};

const CashForACause = ({
  widgetIdentifier,
  coloredTiles,
  primaryColor,
  darkMode,
}) => {
  return (
    <div>
      <Banner
        backgroundImg={
          widgetIdentifier === "mondrianparkavenue"
            ? rewardsOverviewText.cashForACauseSection.bannerImgMondrian
            : widgetIdentifier.includes("yotel")
            ? rewardsOverviewText.cashForACauseSection.bannerImgYotel
            : rewardsOverviewText.cashForACauseSection.bannerImg
        }
        title={rewardsOverviewText.cashForACauseSection.title}
        subtitle={rewardsOverviewText.nonInstayCards[1].description}
        coloredTiles={coloredTiles}
        primaryColor={primaryColor}
      />
      <CashForACauseCards />
      <Line />
      <Footer widgetIdentifier={widgetIdentifier} darkMode={darkMode} />
    </div>
  );
};

CashForACause.propTypes = {
  widgetIdentifier: PropTypes.string.isRequired,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primaryColor: PropTypes.string,
  darkMode: PropTypes.string.isRequired,
};

export default CashForACause;
